<template>
  <div>
    <div ref="quill-input"></div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['value'],
  data() {
    return {
      quill: null,
    }
  },
  mounted() {
    this.quill = new Quill(this.$refs['quill-input'], {
      modules: {
        toolbar: [
          [
            { header: [1, 2, 3, 4, 5, 6, false] },
            { size: ['small', false, 'large', 'huge'] },
            { font: [] },
          ],
          [
            'bold',
            'italic',
            'underline',
            'strike',
            { color: [] },
            { align: ['', 'right', 'center', 'justify'] },
          ],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'clean'],
        ],
      },
      theme: 'snow',
    })

    this.quill.getModule('toolbar').addHandler('image', this.selectFile)
    this.quill.on('editor-change', _.debounce(this.editorChange, 200))

    if (this.value && this.value.quill) {
      if (_.isString(this.value.quill)) {
        this.quill.setContents(JSON.parse(this.value.quill))
      } else {
        let q = _.get(this.value, 'quill.ops.0.insert', null)
        if (q) {
          this.quill.setContents(this.value.quill)
        }
      }
    }
  },
  methods: {
    editorChange(eventName, ...args) {
      if (eventName === 'text-change' || eventName === 'selection-change') {
        this.$emit(
          'quillChanged',
          this.quill.root.innerHTML,
          this.quill.getContents()
        )
      }
    },
  },
}
</script>
